<div class="materials-schema">
  <div>{{schema.SchemaName}}</div>
  <div class="row align-items-center justify-content-end">
    <div class="col col-md-10">
      <div class="progress">
        <div [class.progress-inprogress]="schema.PercentComplete < 100"
             [class.progress-complete]="schema.PercentComplete === 100"
             class="progress-bar" role="progressbar"
             [style.width]="schema.PercentComplete+'%'" attr.aria-valuenow="{{schema.PercentComplete}}" aria-valuemin="0" aria-valuemax="100">
        </div>
      </div>
    </div>
    <div style="text-align: right" class="col col-md-2  mx-0 pl-0 label-text">{{schema.PercentComplete}}%</div>
  </div>
</div>
<project-materials-substage *ngFor="let phase of schema.MaterialsPhases" [phase]="phase"></project-materials-substage>
